import * as ambassadorWixInnovationPlaygroundV2Message from './innovation-playground-v2-message-assistant-training.http.js';
import * as ambassadorWixInnovationPlaygroundV2MessageTypes from './innovation-playground-v2-message-assistant-training.types.js';
import * as ambassadorWixInnovationPlaygroundV2MessageUniversalTypes from './innovation-playground-v2-message-assistant-training.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryMessages(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.QueryMessagesRequest,
  ambassadorWixInnovationPlaygroundV2MessageTypes.QueryMessagesRequest,
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.QueryMessagesResponse,
  ambassadorWixInnovationPlaygroundV2MessageTypes.QueryMessagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationPlaygroundV2Message.queryMessages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/messages/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function askQuestion(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.AskQuestionRequest,
  ambassadorWixInnovationPlaygroundV2MessageTypes.AskQuestionRequest,
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.AskQuestionResponse,
  ambassadorWixInnovationPlaygroundV2MessageTypes.AskQuestionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationPlaygroundV2Message.askQuestion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/messages/ask-question',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addFeedback(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.AddFeedbackRequest,
  ambassadorWixInnovationPlaygroundV2MessageTypes.AddFeedbackRequest,
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.AddFeedbackResponse,
  ambassadorWixInnovationPlaygroundV2MessageTypes.AddFeedbackResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationPlaygroundV2Message.addFeedback(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/messages/add-feedback',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMessageTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.BulkUpdateMessageTagsRequest,
  ambassadorWixInnovationPlaygroundV2MessageTypes.BulkUpdateMessageTagsRequest,
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.BulkUpdateMessageTagsResponse,
  ambassadorWixInnovationPlaygroundV2MessageTypes.BulkUpdateMessageTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationPlaygroundV2Message.bulkUpdateMessageTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/messages/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMessageTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.BulkUpdateMessageTagsByFilterRequest,
  ambassadorWixInnovationPlaygroundV2MessageTypes.BulkUpdateMessageTagsByFilterRequest,
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.BulkUpdateMessageTagsByFilterResponse,
  ambassadorWixInnovationPlaygroundV2MessageTypes.BulkUpdateMessageTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationPlaygroundV2Message.bulkUpdateMessageTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/messages/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixInnovationPlaygroundV2MessageTypes.UpdateExtendedFieldsRequest,
  ambassadorWixInnovationPlaygroundV2MessageUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixInnovationPlaygroundV2MessageTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixInnovationPlaygroundV2Message.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/messages/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Message as MessageOriginal,
  Sender as SenderOriginal,
  SenderWithLiterals as SenderWithLiteralsOriginal,
  Feedback as FeedbackOriginal,
  Document as DocumentOriginal,
  Category as CategoryOriginal,
  CategoryWithLiterals as CategoryWithLiteralsOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  ReferenceDocument as ReferenceDocumentOriginal,
  FeedbackType as FeedbackTypeOriginal,
  FeedbackTypeWithLiterals as FeedbackTypeWithLiteralsOriginal,
  Body as BodyOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  QueryMessagesRequest as QueryMessagesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryMessagesResponse as QueryMessagesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AskQuestionRequest as AskQuestionRequestOriginal,
  AskQuestionResponse as AskQuestionResponseOriginal,
  AddFeedbackRequest as AddFeedbackRequestOriginal,
  AddFeedbackResponse as AddFeedbackResponseOriginal,
  BulkUpdateMessageTagsRequest as BulkUpdateMessageTagsRequestOriginal,
  BulkUpdateMessageTagsResponse as BulkUpdateMessageTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateMessageTagsResult as BulkUpdateMessageTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateMessageTagsByFilterRequest as BulkUpdateMessageTagsByFilterRequestOriginal,
  BulkUpdateMessageTagsByFilterResponse as BulkUpdateMessageTagsByFilterResponseOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
} from './innovation-playground-v2-message-assistant-training.types.js';
